/**=========================================================
 * Module: data.js
 * Data Service
 =========================================================*/

App.service('DataService', ['Restangular', '$rootScope', function(R, $rootScope) {

    function parseQueryString(s) {    
        if(!(typeof s === 'string' || s instanceof String)){
            return s;
        }        
        var pairs = s.split('&');
        
        var result = {};
        pairs.forEach(function(pair) {
            if(pair){
                pair = pair.split('=');
                result[pair[0]] = decodeURIComponent(pair[1] || '');
            }
        });

        return angular.fromJson(angular.toJson(result));
    }

    /*
        cyrb53a (c) 2023 bryc (github.com/bryc)
        License: Public domain. Attribution appreciated.
    */
    const cyrb53a = function(str, seed = 0) {
        let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
        for(let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 0x85ebca77);
        h2 = Math.imul(h2 ^ ch, 0xc2b2ae3d);
        }
        h1 ^= Math.imul(h1 ^ (h2 >>> 15), 0x735a2d97);
        h2 ^= Math.imul(h2 ^ (h1 >>> 15), 0xcaf649a9);
        h1 ^= h2 >>> 16; h2 ^= h1 >>> 16;
        return 2097152 * (h2 >>> 0) + (h1 >>> 11);
    };

  const dataForCache = function($type, filter, data, action, options){
    return { 
        data: JSON.parse(JSON.stringify(data)), 
        expiresAt: FIREBASE.toTimestamp(new Date(new Date().getTime() + 86400000*(options.expiresAfterDays || 1))), 
        filter: action==='query' ? (({ _t, ...o }) => o)(filter) : (({ _t, _cursor, _range, range, ...o }) => o)(filter),
        type: $type.toUpperCase(),
        action: action,
        finished: options.finished!==undefined ? options.finished : true
    }
  }

  const hashForCache = function($type, filter, action){
    if(action==='load'){
        return $type + '@' + filter
    } else {
        let cloneFilter = action==='query' ? (({ _t, ...o }) => o)(filter) : (({ _t, _cursor, _range, range, ...o }) => o)(filter)
        return $type + '#' + cyrb53a(JSON.stringify(cloneFilter))
    }
  }

  function equal(a, b) { //modified from fast-deep-equal (il primo oggetto può essere un sottoinsieme del secondo)
    if (a === b) return true;
  
    if (a && b && typeof a == 'object' && typeof b == 'object') {
      if (a.constructor !== b.constructor) return false;
  
      var length, i, keys;
      if (Array.isArray(a)) {
        length = a.length;
        if (length != b.length) return false;
        for (i = length; i-- !== 0;){
            //modifica rispetto a fast-deep-equal: se l'elemento ha il campo id prendo l'elemento corrispondente (potrebbe avere ordine diverso)
            if(a[i].id){
                if(!equal(a[i], b.find(e => e.id === a[i].id))) return false;
            } else {
                if (!equal(a[i], b[i])) return false;
            }
        }
        return true;
      }
  
  
  
      if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
      if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
      if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
  
      keys = Object.keys(a);
      length = keys.length;
      //modifica rispetto a fast-deep-equal: se la lunghezza è diversa non lo considero
      //if (length !== Object.keys(b).length) return false;
  
      //modifica rispetto a fast-deep-equal: se la chiave non c'è non lo considero
      //for (i = length; i-- !== 0;)
      //  if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
  
      for (i = length; i-- !== 0;) {
        var key = keys[i];
        //modifica rispetto a fast-deep-equal: se la chiave non c'è non lo considero
        if(Object.prototype.hasOwnProperty.call(b, key)){
            if (!equal(a[key], b[key])) {
               // console.log('not equal', key, a[key], b[key], a, b)
                return false;
            }
        }
      }
  
      return true;
    }
  
    // true if both NaN, false otherwise
    return a!==a && b!==b;
  }

  class DoublePromise {
    
    constructor(fn){
        this.fn = fn
        this.callback = () => {}
        this.errorCallback = () => {}
        this.finalCallback = () => {}
        this.data = null
        this.fromCache = false
        this.fromApi = false
    }

    resolve(data, logId, action){
        try{
            if(action=='fromCache'){
                this.fromCache = true
                this.data = data
                L.stack(logId, 'fromCache', data)
                this.callback(data)
            } else if(action=='fromApi'){
                if(this.fromCache){
                    if(!equal(data, this.data)){
                        L.stack(logId, 'fromApiAfterCache', data)
                        this.callback(data)
                    } else {
                        L.stack(logId, 'apiEqualToCache')
                    }
                } else {
                    L.stack(logId, 'fromApi', data)
                    this.callback(data)
                }
                L.stack(logId, 'final').log()
                if(this.finalCallback) this.finalCallback(true)
            }
        } catch(ex){
            this.reject(ex)
        }
    }

    reject(err){
        if(this.errorCallback) this.errorCallback(err)
        if(this.finalCallback) this.finalCallback(false)
    }

    then(cb){
        this.callback = cb
        try{
            this.fn(this.resolve.bind(this), this.reject.bind(this))
        } catch(err) {
            this.reject(err)
        }
        return this
    }

    catch(errCb){
        this.errorCallback = errCb
        return this
    }

    finally(cb){
        this.finalCallback = cb
        return this
    }
  }
  
  return {
    fn: async function($fn, $method, $id, $model){
        let response = await fetch($rootScope.app.config.functionsUrl + '/'+$fn, {
            method: $method || 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + (FIREBASE.token || ''),
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: $model ? JSON.stringify($model) : undefined
        })
        return response.json()
    },
    download: function(url, filename){
        fetch($rootScope.app.config.baseUrl + url, {
            method: 'GET',
            headers: new Headers({
                "Authorization": "Bearer " + FIREBASE.token,
            })
        })
        .then(response => response.blob())
        .then(blob => {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
            a.click();    
            a.remove();  //afterwards we remove the element again         
        });
    },
    call: function($fn, $method, $id, $model){
        //try{ if(_aqrate_user) ga('send', 'event', 'api', _aqrate_user.groupType+'/function', $fn); } catch (e) {}
        if($method && $method.toLowerCase()==='put'){
            return R.one('Function', $fn).customPUT($model || {}, $id || '')
        } else if($method && $method.toLowerCase()==='post'){
            return R.one('Function', $fn).customPOST($model || {}, $id || '')
        } else {
            return R.one('Function', $fn).customGET($id || '', $model || {})
        }
    },
    load: function($type, $filter, options){
        let logId = 'Data.load.'+$type+'.'+$filter
        L.stack(logId, 'call', options)
        options = options || {};
        let promise = new DoublePromise((resolve, reject) => {
            let hash = null
            if(options.cache){
                hash = hashForCache($type, $filter, 'load')
                FIREBASE.readCache($rootScope.user.id, hash, function(data){
                    if(data) {
                        resolve(data.data, logId, 'fromCache')
                    }
                });
            }
            R.one($type, $filter).get().then((data) => {
                if(options.cache){
                    FIREBASE.writeCache($rootScope.user.id, hash, dataForCache($type, $filter, data, 'load', options));
                }
                resolve(data, logId, 'fromApi');
            }).catch((err) => {
                reject(err)
            });
        })
        return promise;
    },
    query: function($type, $filter, options){
        options = options || {};
        let logId = 'Data.query.'+$type+'.'+$filter
        L.stack(logId, 'call', options)
        let filter = $filter ? parseQueryString($filter) : {};
        let promise = new DoublePromise((resolve, reject) => {
            let hash = null
            if(options.cache){
                hash = hashForCache($type, filter, 'query')
                FIREBASE.readCache($rootScope.user.id, hash, function(data){
                    if(data) {
                        resolve(data.data, logId, 'fromCache')
                    }
                });
            }
            R.all($type).getList(filter).then((data) => {
                if(options.cache){
                    FIREBASE.writeCache($rootScope.user.id, hash, dataForCache($type, filter, data, 'query', options));
                }
                resolve(data, logId, 'fromApi');
            });
        })
        return promise;
    },
    stream: function($type, $filter, cb, n, options){
        options = options || {};
        L.stack('Data.stream.' + $type + '.' +$filter, 'call', { n: n, options: options })
        let filter = $filter ? parseQueryString($filter) : {};
        let self = this
        let promise = new Promise((resolve, reject) => {
            let hash = null
            if(options.cache){
                hash = hashForCache($type, filter, 'stream')
                if(!n){
                    let unsub = FIREBASE.readCache($rootScope.user.id, hash, function(data){
                        if(data) {
                            if(cb && data) {
                                let d = data.data
                                d.finished = data.finished
                                let s = L.stack('Data.stream.' + $type + '.' +$filter, 'readCache', { data: data.data.length, finished: data.finished })
                                if(d.finished) s.log()
                                cb(d)
                            }
                        }
                    }, null, { keepOnListening: true });
                }
            }
            R.all($type).getList(filter).then((data) => {
                L.stack('Data.stream.' + $type + '.' +$filter, 'result', { data: data && data.data && data.data.length, cursor: data.cursor })
                if(data && data.cursor){
                    if(options.cache){
                        FIREBASE.streamCache($rootScope.user.id, hash, dataForCache($type, filter, data, 'stream', Object.assign(options, { finished: false })), null, null, { n: n || 0 });
                    } else {
                        data.streamCallN = n || 0
                        cb(data)
                    }
                    let newFilter = $filter.indexOf('_cursor=')>=0 ? $filter.replace(/([&?])_cursor=[^&]*/, '$1_cursor='+data.cursor) : ($filter + '&_cursor='+data.cursor)
                    let newRange = data.length * 2 < 200 ? data.length * 2 : 200
                    newFilter = newFilter.indexOf('_range=')>=0 ? newFilter.replace(/([&?])_range=[^&]*/, '$1_range='+(newRange)) : (newFilter + '&_range='+(newRange))
                    self.stream($type, newFilter, cb, n ? n+1 : 1, options)
                } else {
                    if(options.cache){
                        FIREBASE.streamCache($rootScope.user.id, hash, dataForCache($type, filter, data, 'stream', Object.assign(options, { finished: true })), null, null, { n: n || 0 });
                    } else {
                        data.streamCallN = n || 1
                        data.finished = true
                        cb(data)
                    }
                }
            });
        })
        return promise;
    },
    save: function($type, $model){
        L.log('DataService.save', $type, $model)
        if($model.id){
            if($model.put){
                return $model.put();
            } else {
                return R.one($type, $model.id).customPUT($model);
            }
        } else {
            return R.all($type).post($model);
        }
    },
    remove: function($type, $id){
        L.log('DataService.remove', $type, $id)
        return R.one($type, $id).remove();
    },
    convertDateRangeFilter: function(obj, fromfield, tofield){
        var from = obj[fromfield];
        var to = obj[tofield];
        /*delete obj[fromfield];
        delete obj[fromfield+'_month'];
        delete obj[fromfield+'_year'];
        delete obj[tofield];
        delete obj[tofield+'_month'];
        delete obj[tofield+'_year'];*/
        if(from && !to){
            to = (new Date().getFullYear() + 1) * 100;
        }
        if(to && !from){
            from = 201413
        }
        if(from && to){
            /*var fromY = from.substr(0, 4);
            var fromM = parseInt(from.substr(4));
            var toY = to.substr(0, 4);
            var toM = parseInt(to.substr(4));*/
            var fromN = parseInt(from);
            var toN = parseInt(to);
            var monthsByYear = {};
            for(var i = fromN; i<=toN;){
                var y = Math.floor(i/100);
                var m = i % 100;
                if(!monthsByYear[y]) monthsByYear[y] = [];
                monthsByYear[y].push(m);
                if(m>=12){
                    i = (y+1) * 100 + 1;
                } else {
                    i++;
                }
            }
            obj.month = '';
            for(var y in monthsByYear){
                if(monthsByYear[y].length==12){
                    if(obj.month!='') obj.month += '|';
                    obj.month += '' + y + '';
                } else {
                    for(var k in monthsByYear[y]){
                        var m = monthsByYear[y][k];
                        if(obj.month!='') obj.month += '|';
                        obj.month += '' + y + ('0'+m).substring(('0'+m).length-2);
                    }
                }
            }
        }
        return obj;

    }
  };

}]);